import { Page, type DispatchedAction } from '@eo/shared';

import type { ApproveTaskBody, RejectTaskBody } from './api/types';
import { reviewBoardController } from './controller';
import { ReviewBoardBody } from './ReviewBoardBody';
import type { ReviewBoardState } from './types';

export default function ReviewBoardPage() {
  return (
    <Page<ReviewBoardState> controller={reviewBoardController as never}>
      {({ data, actions }) => (
        <ReviewBoardBody
          data={data}
          onApprove={(body: ApproveTaskBody) => actions.approve(body) as Promise<DispatchedAction>}
          onReject={(body: RejectTaskBody) => actions.reject(body) as Promise<DispatchedAction>}
          onRevert={(payload) => actions.revert(payload) as Promise<DispatchedAction>}
          onLoadMembers={(payload) => void actions.loadMembers(payload)}
          onQueryOptions={(payload) => void actions.queryOptions(payload)}
        />
      )}
    </Page>
  );
}
